export const locale = {
    lang: 'es',
    data: {
      'WIZARD': {
        'VERSION_PROD':{
          '20':'2.0',
          '40':'3.0',
          '41':'3.0',
          '42':'3.0',
        },
        'TESTTITULO': 'TITULO DEL WIZARD :V',
        'CARGANDO': 'Cargando productos adquiridos.',
        'CARGANDO_PULSOS': 'Cargando pulsos en proceso.',
        'SINPRODS': 'No ha adquirido este producto.',
        'EVALUADOR':{
          'TITUTLO':'Evaluador'
        },
        'LANDING': {
          'PRODUCTO': {
            'CERTIFICAR':{
              'TITULO': 'BIENVENIDO A CERTIFICAR',
              'CURRENT': 'Este es el proceso actual de certificación',
              'FINISHED': 'Este es un proceso de certificación concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de certificación no terminado',
                // 'FINISHED': 'Proceso de certificación terminado'
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'Amco':{
              'TITULO': 'BIENVENIDO A AMCO',
              'CURRENT': 'Este es el proceso actual de amco',
              'FINISHED': 'Este es un proceso de amco concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de amco no terminado',
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'Trabajo_digno':{
              'TITULO': 'BIENVENIDO A TRABAJO DIGNO',
              'CURRENT': 'Este es el proceso actual de trabajo digno',
              'FINISHED': 'Este es un proceso de trabajo digno concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de trabajo digno no terminado',
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'Primer_empleo':{
              'TITULO': 'BIENVENIDO A PRIMER EMPLEO',
              'CURRENT': 'Este es el proceso actual de primer empleo',
              'FINISHED': 'Este es un proceso de primer empleo concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de primer empleo no terminado',
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'CERTIFICAR_ESPAIN':{
              'CURRENT': 'Este es el proceso actual de diagnosticar',
              'FINISHED': 'Este es un proceso de diagnosticar concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de certificación no terminado',
                // 'FINISHED': 'Proceso de certificación terminado'
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'CERTIFICAR_C1':{
              'TITULO': 'BIENVENIDO A CERTIFICAR 2.0',
              'CURRENT': 'Este es el proceso actual de certificación',
              'FINISHED': 'Este es un proceso de certificación concluído.',

              //ESPAÑA
              'TITULO_ESPAIN': 'BIENVENIDO A DIAGNOSTICAR',
              'RESULTS': {
                'CURRENT': 'Proceso de certificación no terminado',
                // 'FINISHED': 'Proceso de certificación terminado'
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'CERTIFICAR_C2':{
              'TITULO': 'BIENVENIDO A IZZI',
              'CURRENT': 'Este es el proceso actual de izzi',
              'FINISHED': 'Este es un proceso de izzi concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de izzi no terminado',
                // 'FINISHED': 'Proceso de certificación terminado'
                'FINISHED': 'Este es el proceso actual de izzi'
              }
            },
            'CERTIFICAR_C3':{
              'TITULO': 'BIENVENIDO A CERTIFICAR 3.0',
              'CURRENT': 'Este es el proceso actual de certificación',
              'FINISHED': 'Este es un proceso de certificación concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de certificación no terminado',
                // 'FINISHED': 'Proceso de certificación terminado'
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'CERTIFICAR_C4':{
              'TITULO': 'BIENVENIDO A CERTIFICAR PLATA',
              'CURRENT': 'Este es el proceso actual de certificación',
              'FINISHED': 'Este es un proceso de certificación concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de certificación no terminado',
                // 'FINISHED': 'Proceso de certificación terminado'
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'CERTIFICAR_C6':{
              'TITULO': 'BIENVENIDO A GPTW + GCTI',
              'CURRENT': 'Este es el proceso actual de certificación',
              'FINISHED': 'Este es un proceso de certificación concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de certificación no terminado',
                // 'FINISHED': 'Proceso de certificación terminado'
                'FINISHED': 'Este es el proceso actual de resultados ',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'MEDIR':{
              'TITULO': 'BIENVENIDO A MEDIR',
              'CURRENT': 'Este es el proceso actual de medición',
              'FINISHED': 'Este es un proceso de medición concluído',
              'RESULTS': {
                'CURRENT': 'Proceso de medición no terminado',
                // 'FINISHED': 'Proceso de medición terminado'
                'FINISHED': 'Este es el proceso actual de medición',
                'FINISHED5': 'Proceso de resultados'
              }
            },
            'MEDIR_M1':{
              'TITULO': 'BIENVENIDO A MEDIR MEJORADO',
              'CURRENT': 'Este es el proceso actual de medición',
              'FINISHED': 'Este es un proceso de medición concluído',
              'RESULTS': {
                'CURRENT': 'Proceso de medición no terminado',
                'FINISHED': 'Proceso de medición terminado'
              }
            },
            'MEDIR_M2':{
              'TITULO': 'BIENVENIDO A MEDIR + MST',
              'CURRENT': 'Este es el proceso actual de medición',
              'FINISHED': 'Este es un proceso de medición concluído',
              'RESULTS': {
                'CURRENT': 'Proceso de medición no terminado',
                'FINISHED': 'Proceso de medición terminado'
              }
            },
            'MEDIR_M3':{
              'TITULO': 'BIENVENIDO A MEDIR POR ÁREAS',
              'CURRENT': 'Este es el proceso actual de medición',
              'FINISHED': 'Este es un proceso de medición concluído',
              'RESULTS': {
                'CURRENT': 'Proceso de medición no terminado',
                'FINISHED': 'Proceso de medición terminado'
              }
            },
            'MEDIR_M4':{
              'TITULO': 'BIENVENIDO A MEDIR POR LÍDERES',
              'CURRENT': 'Este es el proceso actual de medición',
              'FINISHED': 'Este es un proceso de medición concluído',
              'RESULTS': {
                'CURRENT': 'Proceso de medición no terminado',
                'FINISHED': 'Proceso de medición terminado'
              }
            },
            'MEDIR_M5':{
              'TITULO': 'BIENVENIDO A MEDIR POR DIMENSIONES',
              'CURRENT': 'Este es el proceso actual de medición',
              'FINISHED': 'Este es un proceso de medición concluído',
              'RESULTS': {
                'CURRENT': 'Proceso de medición no terminado',
                'FINISHED': 'Proceso de medición terminado'
              }
            },
            'MEDIR_M6':{
              'TITULO': 'BIENVENIDO A MEDIR PARA CERTIFICAR',
              'CURRENT': 'Este es el proceso actual de medición',
              'FINISHED': 'Este es un proceso de medición concluído',
              'RESULTS': {
                'CURRENT': 'Proceso de medición no terminado',
                'FINISHED': 'Proceso de medición terminado'
              }
            },
            'MEDIR_M7':{
              'TITULO': 'BIENVENIDO A MEDIR 3.0',
              'CURRENT': 'Este es el proceso actual de medición',
              'FINISHED': 'Este es un proceso de medición concluído',
              'RESULTS': {
                'CURRENT': 'Proceso de medición no terminado',
                'FINISHED': 'Proceso de medición terminado'
              }
            },
            'MEDIR_M8':{
              'TITULO': 'BIENVENIDO A ICI',
              'CURRENT': 'Este es el proceso actual del producto',
              'FINISHED': 'Este es un proceso del producto concluído',
              'RESULTS': {
                'CURRENT': 'Proceso del producto no terminado',
                'FINISHED': 'Proceso del producto terminado'
              }
            },
            'MEDIR_M9':{
              'TITULO': 'BIENVENIDO A INNMOTION SURVEY',
              'CURRENT': 'Este es el proceso actual del producto',
              'FINISHED': 'Este es un proceso del producto concluído',
              'RESULTS': {
                'CURRENT': 'Proceso del producto no terminado',
                'FINISHED': 'Proceso del producto terminado'
              }
            },
            'PULSE':{
              'TITULO': 'BIENVENIDO A PULSE CHECK',
              'ADMINTITULO': 'ADMINISTRADOR  PULSE CHECK´S',
              'PRODU': 'Pulse Check',
              'CURRENT': 'Este es el proceso actual de Pulse Check',
              'PULSOS': 'Este es un proceso de Pulse Check',
              'FINISHED': 'Este es un proceso de Pulse Check concluído',
              'ENTRAR': 'Iniciar',
              'CARGANDO_PULSE':'Cargando pulsechecks en proceso',
              'RESULTS': {
                'CURRENT': 'Proceso de Pulse Check no terminado',
                // 'FINISHED': 'Proceso de Pulse Check terminado'
                'FINISHED': 'Este es el proceso actual de Pulse Check'
              }
            },
            'PULSE_T1':{
              'TITULO': 'BIENVENIDO A PULSE CHECK 3.0',
              'ADMINTITULO': 'ADMINISTRADOR  PULSE CHECK´S',
              'PRODU': 'Pulse Check',
              'CURRENT': 'Este es el proceso actual de Pulse Check',
              'PULSOS': 'Este es un proceso de Pulse Check',
              'FINISHED': 'Este es un proceso de Pulse Check concluído',
              'ENTRAR': 'Iniciar',
              'RESULTS': {
                'CURRENT': 'Proceso de Pulse Check no terminado',
                // 'FINISHED': 'Proceso de Pulse Check terminado'
                'FINISHED': 'Este es el proceso actual de Pulse Check'
              }
            },
            'FOCUS':{
              'SECTION': 'Administrador grupos',
              'TITLE': 'Administrador grupos',
              'SUBTI': 'Selección y/o creación de grupos',
              'LAND': {
                'NAME': 'Nombre de la encuesta',
                'INICIO': 'Fecha de inicio',
                'FIN': 'Fecha de cierre',
                'AVANCE': 'Avance',
                'ESTADO': 'Estado',
                'COMP': 'Comportamiento',
                'CREARENC': 'Crear encuesta',
                'DELETE': 'Eliminar',
                'EDIT': 'Editar',
              },
              'TITULO': 'BIENVENIDO A FOCUS AREA',
              'CURRENT': 'Este es el proceso actual de Focus Area.',
              'FINISHED': 'Este es un proceso de Focus Area concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de Focus Area no terminado',
                'FINISHED': 'Proceso de Focus Area terminado'
              }
            },
            'FOCUS_1':{
              'SECTION': 'Administrador grupos',
              'TITLE': 'Administrador grupos',
              'ADMINTITULO': 'ADMINISTRADOR FOCUS AREAS',
              'SUBTI': 'Selección y/o creación de grupos',
              'PRODU': 'Focus Area',
              'CARGANDO_FOCUS':'Cargando focus area en proceso',
              'TAB_PROC_FOC':'Procesos de Focus Area',
              'TAB_SUBIDA_COLB_FOC':'Subida de colaboradores',
              'INST_MOD_FILTER_1':'Sube tu lista de colabordores',
              'INST_MOD_FILTER_2':'Ingrese a la encuesta de su elección',

              'LAND': {
                'NAME': 'Nombre de la encuesta',
                'INICIO': 'Fecha de inicio',
                'FIN': 'Fecha de cierre',
                'AVANCE': 'Avance',
                'ESTADO': 'Estado',
                'COMP': 'Comportamiento',
                'CREARENC': 'Crear encuesta',
                'DELETE': 'Eliminar',
                'EDIT': 'Editar',
              },
              'TITULO': 'BIENVENIDO A FOCUS AREA',
              'CURRENT': 'Este es el proceso actual de Focus Area.',
              'FINISHED': 'Este es un proceso de Focus Area concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de Focus Area no terminado',
                'FINISHED': 'Proceso de Focus Area terminado'
              }
            },
            'LEADER_GO':{
              'CURRENT': '',
            },
            'GOFLOW':{
              'TITULO': 'Resultado Go Flow',
            },
          },

          'DONE': 'Año de aplicación: ',
          'LEGA': 'Resultados heredados',
          'FOCUS': 'ENCUESTAS DE  FOCUS AREA',
          'ENTRAR': 'Iniciar',
          'IR':'Ir',
          ////instituto turquia///
          'INST-TURQUEY':{
            'TITULO':'Culture Brief ve Culture Audit 5.0',
            'TITULO-1':'Culture Brief ve Culture Audit 5.0',
            'TITULO1':'Culture Brief ve Culture Audit 5.0',
            'TITULO2':'Culture Brief 5.0',
            'TITULO3':'Culture Audit 5.0',
            'TITULO4':'Lista Especial',
          },
          'INST-CHINA':{
            'TITULO':'Culture Audit',
            'TITULO1':'Culture Audit',
            'TITULO2':'Culture Audit 5.0',
            'TITULO3':'Culture Audit SP',
          },
          'INST-ESP':{
            'TITULO':'Culture Audit',
            'TITULO1':'Culture Audit',
            'TITULO2':'Culture Audit 5.0',
            'TITULO3':'Action Plan',
          }
        },
        'STEPSTAT': {
          'LOCK': 'Paso bloqueado',
          'PEND': 'Paso abierto',
          'COMP': 'Paso completado'
        },
        'NOPRODUCTS': {
          'TITULO': 'Su empresa no cuenta con productos adquiridos.',
          'SUBTI': 'Información sobre la oferta.'
        },
        'GUIA35': {
          'TITULO': 'Guía NOM-035-STPS-2018.',
          'SUBTITULO':'Descripción.',
          'DESCRIPCION': 'La NOM-035-STPS-2018 es un instrumento que permite identificar y analizar de forma general los factores de riesgo psicosocial en los centros de trabajo, así como evaluar el entorno organizacional en el que los trabajadores desarrollan sus actividades.',
          'ENTRAR': 'Iniciar'
        },
        'ENCUESTA35': {
          'TITULO': 'Encuestador NOM-035-STPS-2018.',
          'TITULO2': 'Encuestador NOM-035-STPS-2018',
          'SUBTITULO':'Descripción.',
          'DESCRIPCION': 'La siguiente sección pertenece a un encuestador de la NOM-035-STPS-2018, en la cual se identificará los diferentes factores de riesgo psicosocial en el entorno organizacional de los trabajadores.',
          'ENTRAR': 'Iniciar'
        },

        'CERTIFICAR_ESPAIN': {
          'TITULO': 'Diagnosticar',
        },
        'Amco': {
          'TITULO': 'Amco',
        },
        'Trabajo_digno': {
          'TITULO': 'Trabajo digno',
        },
        'Primer_empleo': {
          'TITULO': 'Primer empleo',
        },
        'NOM35V3': {
            'TITULO': 'Norma 035 3.0'
        },
        'CERTIFICAR_C4': {
            'TITULO': 'Certificar plata'
        },
        'CERTIFICAR_C6': {
            'TITULO': 'GPTW + GCTI'
        },
        'CERTIFICAR': {
          'TITULO': 'Certificar',
          'TITULO_ESPAIN': 'Diagnosticar',
          'TITULO_GPTWGCTI': 'GPTW + GCTI',
          'STEPS': {
            'STP1': {
              'WIZBT': 'Idiomas',
              'TITULO': 'Idiomas',
              'SUBTI': 'Selección de idiomas'
            },
            'STP_NPS': {
              'WIZBT': 'NPS',
              'TITULO': 'NPS',
              'SUBTI': 'Edición de NPS'
            },
            'STP1-1': {
              'WIZBT': 'Reactivos',
              'TITULO': 'Reactivos',
              'SUBTI': 'Selección de reactivos'
            },
            'STP1-FOCUS-PLANTILLA': {
              'WIZBT': 'Plantillas',
              'TITULO': 'Plantillas',
              'SUBTI': 'Selección de reactivos'
            },
            'STP2': {
              'WIZBT': 'Prácticas 4ALL',
              'TITULO': 'Prácticas 4ALL',
              'SUBTI': 'Introducción de prácticas 4ALL'
            },
            'STP_CONTROL': {
              'WIZBT': 'Pregunta de control',
              'TITULO': 'Pregunta de control',
              'SUBTI': 'Edición de la pregunta de control'
            },
            'STP3': {
              'WIZBT': 'Demográficos',
              'TITULO': 'Demográficos',
              'SUBTI': 'Ingrese la información de los demográficos a emplear en la encuesta. NOTA: Los demográficos en color amarillo son opcionales'
            },
            'STP3-1': {
              'WIZBT': 'Preguntas abiertas',
              'TITULO': 'Preguntas abiertas',
              'SUBTI': 'Ingrese las preguntas abiertas'
            },
            'STP4': {
              'WIZBT': 'Adicionales',
              'TITULO': 'Adicionales',
              'SUBTI': 'Introducción de preguntas adicionales'
            },
            'STP4-FOCUS-PLANTILLA': {
              'WIZBT': 'Personalizadas',
              'TITULO': 'Personalizadas',
              'SUBTI': 'Introducción de preguntas adicionales'
            },
            'STP4-1': {
              'WIZBT': 'Generar encuesta',
              'TITULO': 'Generar encuesta',
              'SUBTI': 'Genera la encuesta',
              'WIZBT2': 'Encuesta',
              'TITULO2': 'Encuesta',
            },
            'STP5': {
              'WIZBT': 'Colaboradores',
              'TITULO': 'Colaboradores',
              'SUBTI': 'Carga de lista de colaboradores'
            },
            'STP6': {
              'WIZBT': 'Programar encuesta',
              'TITULO': 'Programar encuesta',
              'SUBTI': 'Programe la fecha de lanzamiento y recordatorios de la encuesta'
            },
            'STP7': {
              'WIZBT': 'Envío de correos',
              'TITULO': 'Envío de correos',
              'SUBTI': 'Realice el envío a sus colaboradores de la invitación para realizar la encuesta'
            },
            // 'STP8': {
            //   'WIZBT': 'Cierre de encuesta',
            //   'TITULO': 'Cierre de encuesta',
            //   'SUBTI': 'Avances antes del cierre de la encuesta'
            // },
            'STP8': {
              'WIZBT': 'Seguimiento de encuesta',
              'TITULO': 'Seguimiento de encuesta',
              'SUBTI': 'Avances antes del cierre de la encuesta'
            },
            'STP9': {
              'WIZBT': 'Activar encuesta',
              'TITULO': 'Activar encuesta',
              'SUBTI': 'Realice la activación de la encuesta'
            },
            'STP10': {
              'WIZBT': 'Plantilla',
              'TITULO': 'Realizar modificaciones en la plantilla',
              'SUBTI': 'Realice la activación de la encuesta'
            },
            'STP_VOICE': {
              'WIZBT': 'Configuración de voz',
              'TITULO': 'Establezca la configuración de voz para la encuesta con audio',
              'SUBTI': 'Establezca la configuración de voz para la encuesta con audio'
            }
          }
        },
        'CERTIFICARAMCO': {
          'TITULO': 'AMCO',
        },
        'CERTIFICARTRABADIG': {
          'TITULO': 'Trabajo digno',
        },
        'CERTIFICARADICPRIEMPL': {
          'TITULO': 'Primer empleo',
        },
        'CERTIFICAR_C2': {
          'TITULO': 'Izzi',
        },
        'CERTIFICAR35': {
          'TITULO': 'NOM-035-STPS-2018.',
          'LANDING': {
            'TITULO': 'BIENVENIDO A LA NOM-035-STPS-2018.',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Idiomas.',
              'TITULO': 'Idiomas.',
              'SUBTI': 'Selección de idiomas.'
            },
            'STP2': {
              'WIZBT': 'Prácticas 4ALL.',
              'TITULO': 'Prácticas 4ALL.',
              'SUBTI': 'Introducción de prácticas 4ALL.'
            },
            'STP3': {
              'WIZBT': 'Demográficos.',
              'TITULO': 'Demográficos.',
              'SUBTI': 'Ingrese la información de los demográficos a emplear en la encuesta.'
            },
            'STP4': {
              'WIZBT': 'Adicionales.',
              'TITULO': 'Adicionales.',
              'SUBTI': 'Introducción de preguntas adicionales.'
            },
            'STP5': {
              'WIZBT': 'Colaboradores.',
              'TITULO': 'Colaboradores.',
              'SUBTI': 'Carga de lista de colaboradores.'
            },
            'STP6': {

              'WIZBT': 'Programar encuesta',
              'TITULO': 'Programar encuesta',
              'SUBTI': 'Programe la fecha de lanzamiento y recordatorios de la encuesta'
            },
            'STP7': {
              'WIZBT': 'Envío de correos.',
              'TITULO': 'Envío de correos.',
              'SUBTI': 'Realice el envío a sus colaboradores de la invitación a realizar la encuesta.'
            },
            'STP8': {
              'WIZBT': 'Cierre de encuesta',
              'TITULO': 'Cierre de encuesta',
              'SUBTI': 'Avances antes del cierre de la encuesta'
            },
            'STP9': {
              'WIZBT': 'Plan de comunicación',
              'TITULO': 'Plan de comunicación',
              'SUBTI': 'Dar a conocer la información a los colaboradores.'
            },'STP10':{
              'WIZBT': 'Colaboradores',
              'TITULO': 'Colaboradores',
              'SUBTI': 'Es una encuesta de la NOM-035-STPS-2018'
            }
          }
        },
        'PULSE': {
          'TITULO': 'Pulse Check',
          'LANDING': {
            'TITULO': 'BIENVENIDO A PULSE CHECK',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Idiomas',
              'TITULO': 'Idiomas',
              'SUBTI': 'Selección de idiomas'
            },
            // 'STP1-1': {
            //   'WIZBT': 'Reactivos',
            //   'TITULO': 'Reactivos',
            //   'SUBTI': 'Selección de reactivos'
            // },
            // 'STP2': {
            //   'WIZBT': 'Prácticas 4ALL',
            //   'TITULO': 'Prácticas 4ALL',
            //   'SUBTI': 'Introducción de prácticas 4ALL'
            // },
            // 'STP3': {
            //   'WIZBT': 'Demográficos',
            //   'TITULO': 'Demográficos',
            //   'SUBTI': 'Ingrese la información de los demográficos a emplear en la encuesta'
            // },
            // 'STP3-1': {
            //   'WIZBT': 'Preguntas abiertas',
            //   'TITULO': 'Preguntas abiertas',
            //   'SUBTI': 'Ingrese las preguntas abiertas'
            // },
            // 'STP4': {
            //   'WIZBT': 'Adicionales',
            //   'TITULO': 'Adicionales',
            //   'SUBTI': 'Introducción de preguntas adicionales'
            // },
            // 'STP5': {
            //   'WIZBT': 'Colaboradores',
            //   'TITULO': 'Colaboradores',
            //   'SUBTI': 'Carga de base de datos de colaboradores'
            // },
            'STP6': {
              'WIZBT': 'Programar encuesta',
              'TITULO': 'Programar encuesta',
              'SUBTI': 'Programe las fechas de encuesta Pulse Check'
            },
            'STP7': {
              'WIZBT': 'Envío de correos',
              'TITULO': 'Envío de correos',
              'SUBTI': 'Realice el envío a sus colaboradores de la invitación para realizar la encuesta'
            },
            'STP8': {
              'WIZBT': 'Progreso de encuesta',
              'TITULO': 'Progreso de encuesta',
              'SUBTI': 'Verifique el progreso de las encuestas Pulse Check'
            }
          }
        },
        'PULSE_T1': {
          'TITULO': 'Pulse Check 3.0',
          'LANDING': {
            'TITULO': 'BIENVENIDO A PULSE CHECK 3.0',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          },
          'STEPS': {
          }
        },
        'CERTIFICAR_C1': {
          'TITULO': 'Certificar alternativo',
          'LANDING': {
            'TITULO': 'BIENVENIDO A CERTIFICAR ALTERNATIVO',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR': {
          'TITULO': 'Medir',
          'LANDING': {
            'TITULO': 'BIENVENIDO A MEDIR',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M1': {
          'TITULO': 'Medir mejorado',
          'LANDING': {
            'TITULO': 'BIENVENIDO A MEDIR MEJORADO',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M2': {
          'TITULO': 'Medir + MST',
          'LANDING': {
            'TITULO': 'BIENVENIDO A MEDIR + MST',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M3': {
          'TITULO': 'Medir por áreas',
          'LANDING': {
            'TITULO': 'BIENVENIDO A MEDIR POR ÁREAS',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M4': {
          'TITULO': 'Medir por líderes',
          'LANDING': {
            'TITULO': 'BIENVENIDO A MEDIR POR LÍDERES',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M5': {
          'TITULO': 'Medir por dimensiones',
          'LANDING': {
            'TITULO': 'BIENVENIDO A MEDIR POR DIMENSIONES',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M7': {
          'TITULO': 'Medir 3.0',
          'LANDING': {
            'TITULO': 'BIENVENIDO A MEDIR 3.0',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M8': {
          'TITULO': 'ICI',
          'LANDING': {
            'TITULO': 'BIENVENIDO A ICI',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M9': {
          'TITULO': 'Innmotion survey',
          'LANDING': {
            'TITULO': 'BIENVENIDO A INNMOTION SURVEY',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'MEDIR_M6': {
          'TITULO': 'Medir para certificar',
          'LANDING': {
            'TITULO': 'BIENVENIDO A MEDIR PARA CERTIFICAR',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          }
        },
        'FOCUS': {
          'TITULO': 'Focus Area.',
          'LANDING': {
            'TITULO': 'BIENVENIDO A FOCUS AREA',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Idiomas.',
              'TITULO': 'Idiomas.',
              'SUBTI': 'Selección de idiomas.'
            },
            'STP2': {
              'WIZBT': 'Administrar grupos',
              'TITULO': 'Administrar grupos',
              'SUBTI': 'Ingrese las prácticas 4ALL de su empresa para la encuesta'
            },
            'STP3': {
              'WIZBT': 'Administrar encuestas',
              'TITULO': 'Administrar encuestas',
              'SUBTI': 'Ingrese la información demográfica que será mostrada en la encuesta'
            },
            'STP4': {
              'WIZBT': 'Tablero de encuestas',
              'TITULO': 'Tablero de encuestas',
              'SUBTI': 'Ingrese las preguntas adicionales para la encuesta'
            }
          }
        },
        'FOCUS_1': {
          'TITULO': 'Focus Area.',
          'LANDING': {
            'TITULO': 'BIENVENIDO A FOCUS AREA',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Idiomas.',
              'TITULO': 'Idiomas.',
              'SUBTI': 'Selección de idiomas.'
            },
            'STP2': {
              'WIZBT': 'Administrar grupos',
              'TITULO': 'Administrar grupos',
              'SUBTI': 'Ingrese las prácticas 4ALL de su empresa para la encuesta'
            },
            'STP3': {
              'WIZBT': 'Administrar encuestas',
              'TITULO': 'Administrar encuestas',
              'SUBTI': 'Ingrese la información demográfica que será mostrada en la encuesta'
            },
            'STP4': {
              'WIZBT': 'Tablero de encuestas',
              'TITULO': 'Tablero de encuestas',
              'SUBTI': 'Ingrese las preguntas adicionales para la encuesta'
            }
          }
        },
        'LEADER_GO':{
          'TITULO_ADMIN': 'LEADER GO® BIENVENIDO ADMINISTRADOR',
          'TITULO': 'LEADER GO® BIENVENIDO',
          'TITULO_PRODUCT':'Leader Go® administrador',
          'TITULO_PRODUCT2':'Leader Go®',
          'LANDING': {
            'TITULO': 'BIENVENIDO A LEADER GO',
            'DONE': 'Año de aplicación: ',
            'ENTRAR': 'Iniciar'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Idiomas',
              'TITULO': 'Idiomas',
              'SUBTI': 'Selección de idiomas'
            },
            'STP2': {
              'WIZBT': 'Selección de lideres',
              'TITULO': 'Selección de lideres',
              'SUBTI': 'Seleccione los lideres',
            },
            'STP3': {
              'WIZBT': 'Mensajes de comunicación',
              'TITULO': 'Mensajes de comunicación',
              'SUBTI': 'Ingrese para editar los correos '
            },
            'STP4': {
              'WIZBT': 'Confirmación',
              'TITULO': 'Confirmación',
              'SUBTI': 'Ingrese para confirmar el envio de los correos'
            },
            'STP5': {
              'WIZBT': 'Avance',
              'TITULO': 'Avance',
              'SUBTI': 'Avance'
            }
          }

        },
        'ACTION_GO':{
          'TITULO_ADMIN': 'ACTION GO® BIENVENIDO ADMINISTRADOR',
          'TITULO': 'ACTION GO® BIENVENIDO',
          'TITULO_PRODUCT':'Action GO® administrador',
          'TITULO_PRODUCT2':'Action GO®',
        },
        'LANDING_REQUERIMIENTOSV3':{
            'TITULO':'Requerimientos Técnicos',
            'EXTERNAL_PORTAL': 'Copie la url de los RT externos',
            'COPYA_MESSAGE':'La url se ha copiado en el portapapeles',

        },
        'GOFLOW':{
          'TITULO': 'Resultado Go Flow',
        },
      }
    }
};
